export const PRODUCTS_API = "https://fakestoreapi.com/products";
export const PRODUCT_API = 'https://fakestoreapi.com/products/';
export const CATEGORY_API = 'https://fakestoreapi.com/products/category/';
export const CATEGORIES = 'https://fakestoreapi.com/products/categories';
export const BACKGROUND_COLORS = [
  "#F5EEE6",
  "#FFF8E3",
  "#F3D7CA",
  "#F9F7C9",
  "#EAECCC",
  "#D2E3C8",
  "#B8E0D2",  // Light Green
  "#C9D8E8",  // Light Blue
  "#F0C2C2",  // Light Red
  "#FFE5CC",  // Light Orange
  "#D9D9D9",  // Light Gray
  "#C4E1A6",  // Mint Green
  "#F7E5E5",  // Rose Pink
  "#BDD7FF",  // Sky Blue
  "#FFE08D",  // Pale Yellow
  "#D6C2FF",  // Lavender
];

export const BACKEND_API = 'http://localhost:3000';
export const RENDER_API = 'https://ecommerce-backend-qw7q.onrender.com';
export const VERCEL_API = "https://ecommerce-backend-two-eta.vercel.app/";